import { render, staticRenderFns } from "./ComboTable.vue?vue&type=template&id=8cfd515c&scoped=true"
import script from "./ComboTable.vue?vue&type=script&lang=js"
export * from "./ComboTable.vue?vue&type=script&lang=js"
import style0 from "./ComboTable.vue?vue&type=style&index=0&id=8cfd515c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfd515c",
  null
  
)

export default component.exports